'use client'

import { ExternalLink, PanelLeftClose } from 'lucide-react'
import { SidebarCollapseTrigger } from 'fumadocs-ui/components/sidebar/base'
import { DocsLanguageToggle } from '@/components/docs/DocsLanguageToggle'
import { ThemeToggle } from '@/components/theme/ThemeToggle'
import { DOCS_CHROME, i18n } from '@/lib/docs-i18n'
import type { DocsTheme } from '@/lib/docs-theme'

type DocsSidebarFooterProps = {
  locale: (typeof i18n.languages)[number]
  initialTheme: DocsTheme
  onLocaleChange: (nextLocale: string) => void
}

/** Footer: quiet HumanByte referrer, then language + theme (collapse follows from Fumadocs). */
export function DocsSidebarFooter({ locale, initialTheme, onLocaleChange }: DocsSidebarFooterProps) {
  const chrome = DOCS_CHROME[locale]

  return (
    <div className="docs-sidebar-footer">
      <a
        href="https://humanbyte.ch"
        target="_blank"
        rel="noreferrer noopener"
        className="docs-sidebar-humanbyte-link"
      >
        <ExternalLink className="size-3.5 shrink-0" aria-hidden />
        <span>{chrome.humanbyte}</span>
      </a>
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <DocsLanguageToggle locale={locale} onChange={onLocaleChange} />
        <ThemeToggle initialPreference={initialTheme} size="inline" />
      </div>
      <SidebarCollapseTrigger className="bk-only-md-up-flex min-h-8 min-w-8 items-center justify-center">
        <PanelLeftClose className="size-4" aria-hidden />
      </SidebarCollapseTrigger>
    </div>
  )
}
